import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import ContentContainer from '@piconetworks/content-container'
import Image from '@piconetworks/image'
import Avatar from '@piconetworks/avatar'

import style from './Overlay.module.scss'

class Overlay extends React.Component {
    closeHeader = () => {
        const {
            showLauncher,
        } = this.props

        showLauncher()
    }

    render() {
        const {
            children,
            contrastColor,
            linkColor,
            coverPhoto,
            logoColor,
            avatarImg,
            isAvatarPage,
        } = this.props

        const headerStyle = {
            backgroundColor: linkColor,
            color: contrastColor,
        }

        return (
            <div className={style.overlay}>
                <ContentContainer className={style.contentContainer}>
                    <button className={style.closeButton} type="button" onClick={this.closeHeader}>
                        <svg title="Close" icon="M16.936 18.361L12 13.425l-4.936 4.936a1.008 1.008 0 1 1-1.425-1.425L10.575 12 5.639 7.064A1.008 1.008 0 1 1 7.064 5.64L12 10.575l4.936-4.936a1.008 1.008 0 1 1 1.425 1.425L13.425 12l4.936 4.936a1.008 1.008 0 1 1-1.425 1.425z" color={linkColor} cursor="pointer" display="block" width="24px" className="clickable" height="24px" viewBox="0 0 24 24" role="img" aria-labelledby="svg-title" style={{ cursor: 'pointer', display: 'block', verticalAlign: 'middle' }}>
                            <title id="svg-title">Close</title>
                            <path d="M16.936 18.361L12 13.425l-4.936 4.936a1.008 1.008 0 1 1-1.425-1.425L10.575 12 5.639 7.064A1.008 1.008 0 1 1 7.064 5.64L12 10.575l4.936-4.936a1.008 1.008 0 1 1 1.425 1.425L13.425 12l4.936 4.936a1.008 1.008 0 1 1-1.425 1.425z" fill={linkColor} />
                        </svg>
                    </button>
                    <div className={classNames(style.modalTopBorder)} style={headerStyle} />
                    <Image.CoverPhoto
                        className={classNames(style.banner)}
                        style={{ backgroundImage: `url(${coverPhoto})` }}
                    >
                        {!!avatarImg && isAvatarPage && (
                            <div className={style.bannerAvatar}>
                                <Avatar
                                    src={avatarImg}
                                    // width and height is passed as inline style
                                    // this is because to overwrite defaults
                                    style={{ backgroundColor: logoColor, width: '90px', height: '90px' }}
                                />
                            </div>
                        )}
                    </Image.CoverPhoto>
                    {children}
                </ContentContainer>
                <br />
                <br />
            </div>
        )
    }
}

Overlay.defaultProps = {
    children: null,
    showLauncher: null,
    contrastColor: null,
    linkColor: null,
    coverPhoto: null,
    logoColor: null,
    avatarImg: null,
    isAvatarPage: false,
}

Overlay.propTypes = {
    children: PropTypes.node,
    showLauncher: PropTypes.func,
    contrastColor: PropTypes.string,
    linkColor: PropTypes.string,
    coverPhoto: PropTypes.string,
    logoColor: PropTypes.string,
    avatarImg: PropTypes.string,
    isAvatarPage: PropTypes.bool,
}

export default Overlay
